// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3oZwc";
var _3 = "fares-3kAX3";
var _4 = "content-1xhiH";
var _5 = "content_fullWidth-2TOD-";
export { _1 as "__esModule", _2 as "container", _3 as "fares", _4 as "content", _5 as "content_fullWidth" }
export default { "__esModule": _1, "container": _2, "fares": _3, "content": _4, "content_fullWidth": _5 }
